export default theme => ({

  root: {
    display: 'flex',
    justifyContent: 'center',

    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing.unit * 34
    }
  }

})



// WEBPACK FOOTER //
// ./src/styles/pages/profile.js